import { render, staticRenderFns } from "./TrainingMenu.vue?vue&type=template&id=6cf07188&scoped=true&"
import script from "./TrainingMenu.vue?vue&type=script&lang=js&"
export * from "./TrainingMenu.vue?vue&type=script&lang=js&"
import style0 from "./TrainingMenu.vue?vue&type=style&index=0&id=6cf07188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf07188",
  null
  
)

export default component.exports